var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$equipment !== null)?_c('div',[_c('H5Home')],1):_c('div',[_c('PcHome')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }